import { createReducer, on } from '@ngrx/store';
import { cloneDeep, merge } from 'lodash-es';
import { DeepPartial } from '../../utils/types';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import * as actions from './se-side-nav.actions';
import { SeSideNavState, seSideNavComponentInitialState } from './se-side-nav.state';

export const seSideNavReducer = createReducer(
    seSideNavComponentInitialState,
    on(actions.seSideNavComponentSetActiveComponents, (state, { activationList, customProps }) =>
        setActiveComponents(state, activationList, customProps)
    ),
    on(actions.sideTabClicked, (state, { componentType }) => {
        // aggiorno lo stato solo quando cambio tab e non al toggle
        if (state.lastClickedTab === componentType) return state;
        return {
            ...state,
            lastClickedTab: componentType
        };
    }),
);

function setActiveComponents(
    state: SeSideNavState,
    activationList: SeSideComponentType[],
    customProps?: DeepPartial<SeSideNavState['components']>
): SeSideNavState {
    const newComponents = cloneDeep(state.components);

    // Prendo solo le chiavi che sono tipi di componente
    const componentKeys = Object.values(SeSideComponentType);

    for (const key of componentKeys) {
        newComponents[key].active = false;
    }

    for (const key of activationList) {
        newComponents[key].active = true;
    }

    return {
        ...state,
        components: customProps ? merge(newComponents, customProps) : newComponents
    };
}
